import React, { Fragment, useState, useEffect } from 'react';
import Tooltip from '../tooltip/Tooltip';
import { Modal, ModalHeader, ModalBody } from '../modal/Modal';

const FysicalScoreReportView = (props) => {
    const [modalFullScreen, setModalFullScreen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const { open, url, toggleFysicalReportModal } = props;

    // Reset loading state when modal opens or URL changes
    useEffect(() => {
        if (open) {
            setIsLoading(true);
        }
    }, [open, url]);

    const onClickToggleModalScreenSize = (e) => {
        e.preventDefault();
        setModalFullScreen(!modalFullScreen);
    };

    const getFullScreenModalStyle = () => {
        if (modalFullScreen) {
            return 'modal-full-screen'
        }
    };

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    return (
        <Modal isOpen={open} className={`modal-lg report ${getFullScreenModalStyle()}`}>
            <ModalHeader toggle={toggleFysicalReportModal}>
                Report &nbsp;&nbsp;
                {modalFullScreen && (
                    <Fragment>
                        <a rel="noopener noreferrer" href={"!#"}
                           className="modal-action-btn"
                           onClick={onClickToggleModalScreenSize}
                           id="btnMinimize">
                            <span>
                                <i className={modalFullScreen ? "fa fa-compress" : "fa fa-expand"}/>
                            </span>
                        </a>
                        <Tooltip
                            placement="bottom"
                            target="btnMinimize">
                            MINIMIZE SCREEN
                        </Tooltip>
                    </Fragment>
                )}
                {!modalFullScreen && (
                    <Fragment>
                        <a rel="noopener noreferrer" href={"!#"}
                           className="modal-action-btn"
                           onClick={onClickToggleModalScreenSize}
                           id="btnMaximize">
                            <span>
                                <i className={modalFullScreen ? "fa fa-compress" : "fa fa-expand"}/>
                            </span>
                        </a>
                        <Tooltip
                            placement="bottom"
                            target="btnMaximize">
                            FULL SCREEN
                        </Tooltip>
                    </Fragment>
                )}
            </ModalHeader>
            <ModalBody>
                {isLoading && <div className="report-spinner" aria-hidden="true" />}
                <div className="embed-wrapper embed-21by9">
                    <iframe
                        className="embed-frame"
                        title="Report"
                        src={url}
                        onLoad={handleIframeLoad}
                    />
                </div>
            </ModalBody>
        </Modal>
    );
};

export default FysicalScoreReportView;
